import { render, staticRenderFns } from "./ForwarderArea.vue?vue&type=template&id=1944658c"
import script from "./forwarderArea.ts?vue&type=script&lang=js&external"
export * from "./forwarderArea.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports